<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.userList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <form role="form">
                            <div class="row">

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.setting.name')}}</label>
                                        <input type="text" v-model="search.name" @keyup="searchUser"
                                            class="search form-control">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.setting.username')}}</label>
                                        <input type="text" v-model="search.username" @keyup="searchUser"
                                            class="search form-control">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.setting.email')}}</label>
                                        <input type="text" v-model="search.email" @keyup="searchUser"
                                            class="search form-control">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.setting.partnerCode')}}</label>
                                        <v-select label="PartnerCode" :options="partners" v-model="search.partnerId"
                                            @input="searchUser"
                                            :reduce="partners => partners.PartnerID">
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.setting.status')}}</label>
                                        <select class="form-control" v-model="search.status" @change="searchUser">
                                            <option value="1">{{$t('form.setting.enabled')}}</option>
                                            <option value="0">{{$t('form.setting.disabled')}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.setting.userList')}}</div>

                        <button class="btn btn-primary btn-sm float-right" @click="addNewUser()"
                            v-if="permissions.createSettingsUsers">{{$t('button.new')}}</button>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="users.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.setting.name')}}</th>
                                    <th>{{$t('form.setting.username')}}</th>
                                    <th>{{$t('form.setting.email')}}</th>
                                    <th>{{$t('form.setting.partnerCode')}}</th>
                                    <th>{{$t('form.setting.roles')}}</th>
                                    <th>{{$t('form.setting.authenticateMethod')}}</th>
                                    <th>{{$t('form.setting.status')}}</th>
                                    <th class="text-right">{{$t('form.setting.action')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(user,index) in users" v-bind:key="index" @dblclick="editUser(user.id)">
                                    <td>{{user.name}}</td>
                                    <td>{{user.username}}</td>
                                    <td>{{user.email}}</td>
                                    <td>{{user.partner ? user.partner.PartnerCode : ''}}</td>
                                    <td>{{ user.roles.map(role => role.name).join(', ') }}</td>
                                    <td>{{user.authenticate_by}}</td>
                                    <td v-if="user.status == 1">{{$t('form.setting.enabled')}}</td>
                                    <td v-else-if="user.status == 0">{{$t('form.setting.disabled')}}</td>
                                    <td v-else></td>
                                    <td class="text-right">
                                        <button type="button" class="btn btn-info btn-sm" @click="editUser(user.id)"
                                            v-if="permissions.viewSettingsUsers">
                                            <i class="fa fa-edit"></i>
                                        </button>

                                        <button class="btn btn-danger btn btn-sm personal_btn_info"
                                            v-on:click="deleteUser(user.id, index)"
                                            v-if="permissions.deleteSettingsUsers">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                search: {
                    status: 1
                },

                pagination: {
                    current_page: 1
                },

                requestSource: '',
                users: [],
                partners: [],
                selectedRoles: [],
                roles: [],
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsUsers) {
                this.$router.push('/');
                return;
            }

            this.getInitialData();

            this.getUsers();
        },

        watch: {},

        methods: {
            clearSearch() {
                this.search = {status: 1};
                this.searchUser();
            },

            searchUser() {
                this.pagination.current_page = 1;
                this.getUsers();
            },

            getInitialData() {
                axios
                    .get('/api/users/initial-data')
                    .then((response) => {
                        this.partners = response.data.partners;
                    })
                    .catch(error => console.log(error.response));
            },

            addNewUser() {
                if (!this.permissions.createSettingsUsers) return;

                this.$router.push({
                    name: 'UserCreate'
                })
            },

            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },

            paginate() {
                this.getUsers();
            },

            getUsers() {
                let source = axios.CancelToken.source();

                if (this.requestSource != '')
                    this.requestSource.cancel('Operation canceled by the user.');
                    console.clear();

                this.requestSource = source;

                this.isLoading = true;

                axios
                    .get('/api/users?page=' + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.requestSource.token
                    })
                    .then((response) => {
                        this.users = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                    });
            },

            editUser(id) {
                if (!this.permissions.viewSettingsUsers) return;

                this.$router.push({
                    name: 'UserEdit',
                    params: {
                        id: id
                    }
                });
            },

            deleteUser(id, index) {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    this.isLoading = true;

                    axios
                        .delete('/api/users/' + id)
                        .then(response => {
                            if (response.status == 200) {
                                this.showAlert(response.data);

                                // remove deleted user from user's list
                                this.users.splice(index, 1);

                                this.isLoading = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;

                            this.showAlert(error.response.data, 'warning');
                        });
                }
            },
        }
    }

</script>
